module.exports = __webpack_public_path__ + "img/Dropdown.77139cbb.svg";